import { DataReversePayroll, ListReversePayroll } from './types'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
export * from './types'

const http = new HttpService()
/**
 * Consultas generales
 */
export async function getReversePayrollRequest(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<ListReversePayroll> {
  const where = ['reverse_payroll_requests.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(processes.name,reverse_payroll_requests.user,process_status.name,reverse_payroll_requests.observation) ILIKE '%${search}%'`
    )
  }

  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by reverse_payroll_requests.created_at desc'])

  const response = await getData<any>({
    tables: ['pg_reverse_payroll_requests'],
    fields: [
      'processes.name as processName',
      "TO_CHAR(reverse_payroll_requests.start_date,'dd/mm/yyyy') as startDate",
      "TO_CHAR(reverse_payroll_requests.end_date,'dd/mm/yyyy') as endDate",
      'reverse_payroll_requests.user',
      'reverse_payroll_requests.created_at as createdAt',
      'process_status.code as status',
      'reverse_payroll_requests.errors',
      'reverse_payroll_requests.observation',
      'reverse_payroll_requests.errors_reverse_accounting as errorsReverseAccounting',
      'ps.name as statusReverseAccounting',
      'closed_payrolls.ledger_transactions as ledgerTransactions'
    ],
    join: [
      'INNER JOIN processes ON reverse_payroll_requests.process_id=processes.id',
      'INNER JOIN process_status ON reverse_payroll_requests.process_status_id=process_status.id',
      'INNER JOIN closed_payrolls ON reverse_payroll_requests.closed_payroll_id=closed_payrolls.id',
      'INNER JOIN process_status ps ON reverse_payroll_requests.status_reverse_accounting_id=ps.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return response[0]
}

export async function getProcessCountry(): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_processes'],
    fields: ['processes.id', 'processes.name', 'processes.code'],
    join: [
      'INNER JOIN LATERAL jsonb_array_elements_text(processes.countries) c(country) ON TRUE',
      'INNER JOIN countries ON countries.id = c.country::uuid'
    ],
    where: ['countries.id in (:countryId)']
  })

  return response[0].results
}

export async function getProcessClosedPayroll(
  idProcess: string,
  codeProcess: string,
  countryId?: string
): Promise<any> {
  const dateEnd: string = await getRecentDate(idProcess)
  const lastPayment = await getLastPaymentDate()

  if (dateEnd === '' && codeProcess !== 'E' && codeProcess !== 'L') return []

  const queryMx = [
    `stamped_payrolls.id AS stamped_payroll_id`,
  ]
  const joinMx = [
    `LEFT JOIN stamped_payrolls ON closed_payrolls.id = stamped_payrolls.closed_payroll_id AND stamped_payrolls.is_deleted = false`,
  ]

  const where = [
    `processed_payrolls.process_id='${idProcess}'`,
    'closed_payrolls.payroll_id=:payrollId'
  ]

  codeProcess === 'L' || codeProcess === 'E'
    ? where.push(
        `processed_payrolls.created_at >= NOW() - INTERVAL '6 month'`
      )
    : where.push(
        `TO_CHAR(processed_payrolls.end_date,'yyyy-mm-dd')='${dateEnd}'`
      )

  const response = await getData<any>({
    tables: ['pg_closed_payrolls'],
    fields: [
      'closed_payrolls.id',
      'processed_payrolls.process_id',
      "coalesce(string_agg(distinct concat(employees.code,' - ',employees.name),','),'') as employees",
      'count(processed_payrolls.concepts) as total_concepts',
      'processed_payrolls.neto',
      "TO_CHAR(processed_payrolls.start_date,'yyyy-mm-dd') as start_date",
      "TO_CHAR(processed_payrolls.end_date,'yyyy-mm-dd') as end_date",
      'currencies.symbol',
      "TO_CHAR(processed_payrolls.created_at,'yyyy-mm-dd') as created_at",
      ...(countryId === 'MX' ? queryMx : [])
    ],
    join: [
      'INNER JOIN processed_payrolls ON closed_payrolls.processed_payroll_id=processed_payrolls.id',
      'INNER JOIN LATERAL jsonb_array_elements_text(processed_payrolls.employees) m(employees) ON TRUE',
      'INNER JOIN employees ON employees.id = m.employees::uuid',
      'INNER JOIN payrolls ON closed_payrolls.payroll_id=payrolls.id',
      'INNER JOIN currencies ON payrolls.currency_id=currencies.id',
      ...(countryId === 'MX' ? joinMx : [])
    ],
    modifier: [
      `group by closed_payrolls.id,processed_payrolls.process_id,processed_payrolls.concepts,processed_payrolls.neto,processed_payrolls.start_date,processed_payrolls.end_date,currencies.symbol,processed_payrolls.created_at${countryId === 'MX' ? ', stamped_payrolls.id' : ''}`,
      'order by processed_payrolls.end_date desc'
    ],
    where
  })
  return response[0].results
}

export async function getRecentDate(idProcess: string): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_closed_payrolls'],
    fields: ["TO_CHAR(processed_payrolls.end_date,'yyyy-mm-dd') as end_date"],
    join: [
      'INNER JOIN processed_payrolls ON closed_payrolls.processed_payroll_id=processed_payrolls.id'
    ],
    where: [
      `processed_payrolls.process_id='${idProcess}'`,
      'closed_payrolls.payroll_id=:payrollId'
    ],
    modifier: ['order by processed_payrolls.end_date desc']
  })

  return response[0].results.length === 0 ? '' : response[0].results[0].end_date
}

export async function getLastPaymentDate(): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_payrolls'],
    fields: [
      "TO_CHAR(last_payment - interval '6 month','yyyy-mm-dd') as lastPayment"
    ],
    where: ['id=:payrollId'],
    modifier: ['order by last_payment desc']
  })

  return response[0].results[0].lastPayment
}

export async function reversePayroll(data: DataReversePayroll): Promise<any> {
  const response: any = await http.post('calculation/reverse-request', {
    closedPayrollId: data.closedPayrollId,
    observation: data.observation
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}
